import { createAction } from 'redux-actions';
import { actionTypePrefix } from './constants';
const clickWatchAction = createAction(`${actionTypePrefix}/CLICK_WATCH`, (user, isWatching, onToggleWatchSuccess)=>({
        user,
        isWatching,
        onToggleWatchSuccess
    }));
// TS shenanigans...
export const clickWatch = clickWatchAction;
export const requestSuccess = createAction(`${actionTypePrefix}/REQUEST_SUCCESS`, (username, isWatching)=>({
        username,
        isWatching
    }));
export const requestFailure = createAction(`${actionTypePrefix}/REQUEST_FAILURE`, (username, error)=>({
        username,
        error
    }));
export const setWatchingState = createAction(`${actionTypePrefix}/SET_WATCHING_STATE`, (username, isWatching)=>({
        username,
        isWatching
    }));
